import { Spacer } from '#app/components/spacer.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { chromeExtensionLink } from '#app/utils/chrome-extension.ts'
import { mdxStyleLinks } from '#app/utils/mdx.ts'
import { cn } from '#app/utils/misc.tsx'

export const links = mdxStyleLinks
export const meta = [
	{ title: 'SwapMyFace | Chrome extension' },
	{
		name: 'description',
		content:
			'Add the SwapMyFace extension to your Chrome browser to start doing face swaps with any picture on the internet, pinterest, midjourney, instagram, etc... It saves you hours and boosts your productivity!',
	},
]

export default function ChromeExtension() {
	let container = 'max-w-4xl mx-auto'
	return (
		<div className="noise-bg mdx min-h-screen">
			<header className="bg-secondary-foreground/5 px-4 pb-8">
				<Spacer size="xs" />
				<div className={container}>
					<h1 className="text-h1">Do a face swap with a chrome extension</h1>
					<h4 className="max-w-xl font-light">
						Start doing face swaps with just 1 click on any picture on the
						internet: pinterest, midjourney, instagram, etc... It's sooo easy!
					</h4>
					<Spacer size="4xs" />
					<a
						className="bg-app-gradient flex w-fit justify-center rounded-xl border-[1px] border-solid px-8 py-3 text-white"
						href={chromeExtensionLink}
						target="_blank"
						rel="noreferrer"
					>
						<span className="text-white">
							<Icon size="lg" name="download" className="mr-2" />
							Get our chrome extension now!
						</span>
					</a>
					<Spacer size="4xs" />
					<video
						className="rounded-md"
						src="/img/video/chrome-ext.mp4"
						autoPlay
						loop
						muted
						playsInline
					/>
				</div>
			</header>
			<Spacer size="xs" />
			<main className={cn(container, 'px-4')}>
				<p>
					Do you want to easily swap your face into photos and videos? Then you
					need the SwapMyFace Chrome extension!
				</p>
				<p>
					The SwapMyFace Chrome extension makes face swapping faster and simpler
					than ever. You can put your face anywhere in seconds, without leaving
					your browser. It is also the <b>ONLY</b> extension that lets you do
					this at the moment.
				</p>
				<h2>What the SwapMyFace Chrome Extension Does</h2>
				<p>
					The SwapMyFace extension adds face swapping powers to Chrome. Here is
					what it lets you do:
				</p>
				<ul>
					<li>Quickly swap your face into any picture on the web</li>
					<li>Save swapped photos with one click</li>
					<li>Enjoy the simple and modern SwapMyFace interface</li>
				</ul>
				<p>
					You don't need any extra apps or software. The extension does it all!
				</p>
				<h2>How to Add the Extension to Chrome</h2>
				<p>Adding SwapMyFace to Chrome is easy peasy:</p>
				<ol>
					<li>
						Open the{' '}
						<a href="https://chrome.google.com/webstore/detail/swapmyface-ai/jokmnalkdbmbjehcjjnhmeibpfcblddm">
							Chrome web store
						</a>
					</li>
					<li>Search for "SwapMyFace"</li>
					<li>Click "Add to Chrome"</li>
					<li>The extension icon will appear near the top</li>
				</ol>
				<p>Now you have instant access to SwapMyFace anytime you use Chrome!</p>
				<h2>Swapping Faces in Seconds</h2>
				<p>
					Ready to swap your face? Just right click any picture you want to be
					in and select "Put my face in this picture"
				</p>
				<p>
					Upload a photo of your face and let SwapMyFace work its magic. It uses
					smart AI to realistically swap your face into the image or video.
				</p>
				<p>
					In just seconds you can save and share the fun results with friends.
					They'll love seeing your face creatively swapped into media!
				</p>
				<Spacer size="2xs" />
			</main>
		</div>
	)
}
